import { render, staticRenderFns } from "./BriqInput.vue?vue&type=template&id=6d3c471e&scoped=true&lang=pug&"
import script from "./BriqInput.vue?vue&type=script&lang=js&"
export * from "./BriqInput.vue?vue&type=script&lang=js&"
import style0 from "./BriqInput.vue?vue&type=style&index=0&id=6d3c471e&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3c471e",
  null
  
)

export default component.exports